import { useEffect, useState } from "react";

/** `navigator.onLine`, kept current through the window's online/offline
 *  events. It reports a link, not reachability, which is all the overlay
 *  controls need: offline they are disabled, online the Worker answers. */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const on = (): void => setOnline(true);
    const off = (): void => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return online;
}
